import { literalParamWithDefault, parseableSearchSchema } from "@crm/effect/schema/search";
import { Schema } from "effect";

export const goalTemplatesSearchSchema = parseableSearchSchema(
  Schema.Struct({
    level: literalParamWithDefault(["D", "C", "B", "A", "S"], "D"),
  }),
);

export type GoalTemplatesSearch = Schema.Schema.Type<typeof goalTemplatesSearchSchema>;
